const routes = [
    {
        path: "/bulk/import",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
        },
        component_full_path: 'bulkImport/pages/Index'
    }
];

export default routes;
